import { get } from '@helpers'

const mapArrayEntityItems = <T>(array: any[] | null = [], path: string = ''): T[] => {
	return array ? array.map((item) => get(item, path)) : []
}

export default mapArrayEntityItems
